// Mock data for SAMANVAI Platform

export const companyLogos = [
  { name: 'Microsoft', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Microsoft_logo.svg/200px-Microsoft_logo.svg.png' },
  { name: 'Deloitte', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Deloitte.svg/200px-Deloitte.svg.png' },
  { name: 'Google', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Google_2015_logo.svg/200px-Google_2015_logo.svg.png' },
  { name: 'IBM', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/IBM_logo.svg/200px-IBM_logo.svg.png' },
  { name: 'SAP', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/SAP_2011_logo.svg/200px-SAP_2011_logo.svg.png' },
  { name: 'Accenture', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Accenture.svg/200px-Accenture.svg.png' },
];

export const solutions = [
  {
    id: 'performance-insights',
    title: 'Performance Insights',
    description: 'Real-time KPI monitoring and analytics powered by Agentic AI. Track your organization\'s performance against industry benchmarks and top performers in your sector with verified, actionable insights.',
    icon: 'chart',
  },
  {
    id: 'benchmark-intelligence',
    title: 'Benchmark Intelligence',
    description: 'Compare your organization\'s KPIs with industry averages and top performers. Understand where you stand and identify opportunities for improvement with AI-driven recommendations.',
    icon: 'target',
  },
  {
    id: 'impact-intelligence',
    title: 'Impact Intelligence',
    description: 'Quantify the financial impact of improving each KPI by 1%. Get executive-ready reports showing ROI projections and strategic recommendations for the next 5 years.',
    icon: 'trending',
  },
];

export const features = [
  'Top 10 KPIs relevant for your organization',
  'Industry average benchmark comparisons',
  'Top performer analysis in your sector',
  'Financial impact of 1% KPI improvement',
  'Executive dashboard with insights',
  '5-year strategic roadmap recommendations',
];

export const kpiData = [
  {
    name: 'Revenue Growth Rate',
    yourValue: 8.5,
    industryAvg: 6.2,
    topPerformer: 15.3,
    unit: '%',
    impactPer1Percent: 12500000,
  },
  {
    name: 'Operating Margin',
    yourValue: 14.2,
    industryAvg: 12.8,
    topPerformer: 22.5,
    unit: '%',
    impactPer1Percent: 8900000,
  },
  {
    name: 'Customer Retention Rate',
    yourValue: 87.3,
    industryAvg: 82.5,
    topPerformer: 95.2,
    unit: '%',
    impactPer1Percent: 4500000,
  },
  {
    name: 'Employee Productivity',
    yourValue: 245000,
    industryAvg: 218000,
    topPerformer: 312000,
    unit: '$/employee',
    impactPer1Percent: 2800000,
  },
  {
    name: 'Asset Turnover',
    yourValue: 1.8,
    industryAvg: 1.5,
    topPerformer: 2.4,
    unit: 'x',
    impactPer1Percent: 3200000,
  },
  {
    name: 'Days Sales Outstanding',
    yourValue: 42,
    industryAvg: 48,
    topPerformer: 28,
    unit: 'days',
    impactPer1Percent: 1800000,
  },
  {
    name: 'R&D Efficiency',
    yourValue: 3.2,
    industryAvg: 2.8,
    topPerformer: 4.5,
    unit: 'ratio',
    impactPer1Percent: 5600000,
  },
  {
    name: 'Market Share',
    yourValue: 12.5,
    industryAvg: 8.3,
    topPerformer: 28.7,
    unit: '%',
    impactPer1Percent: 18500000,
  },
  {
    name: 'EBITDA Margin',
    yourValue: 18.7,
    industryAvg: 15.2,
    topPerformer: 26.8,
    unit: '%',
    impactPer1Percent: 7200000,
  },
  {
    name: 'Return on Invested Capital',
    yourValue: 11.2,
    industryAvg: 9.5,
    topPerformer: 18.4,
    unit: '%',
    impactPer1Percent: 9800000,
  },
];

export const testimonials = [
  {
    quote: "SAMANVAI transformed how we approach strategic planning. The AI-driven insights helped us identify a 23% improvement opportunity in our supply chain efficiency.",
    author: "Chief Operating Officer",
    company: "Fortune 500 Manufacturing",
  },
  {
    quote: "The benchmark comparisons gave our board exactly what they needed - clear, data-driven evidence of where we stand versus top performers and a roadmap to get there.",
    author: "Chief Financial Officer",
    company: "Global Technology Company",
  },
  {
    quote: "Within 3 months of using SAMANVAI, we implemented changes that improved our operating margin by 2.3%. The ROI was immediate and measurable.",
    author: "Chief Executive Officer",
    company: "Healthcare Services Leader",
  },
];

export const blogPosts = [
  {
    id: 1,
    title: 'How AI is Revolutionizing CXO Decision Making',
    excerpt: 'Discover how Agentic AI enables executives to make data-driven decisions faster and more accurately than ever before.',
    date: 'May 14, 2025',
    category: 'AI Insights',
    author: 'Dr. Priya Sharma',
    image: 'https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=400',
  },
  {
    id: 2,
    title: 'The Top 10 KPIs Every CXO Should Monitor in 2025',
    excerpt: 'Industry experts reveal the most critical performance indicators that separate top performers from the rest.',
    date: 'April 28, 2025',
    category: 'Performance',
    author: 'Rajesh Kumar',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400',
  },
  {
    id: 3,
    title: 'Benchmarking Best Practices: Learning from Industry Leaders',
    excerpt: 'How the best companies use benchmarking to continuously improve and stay ahead of the competition.',
    date: 'April 15, 2025',
    category: 'Strategy',
    author: 'Anita Desai',
    image: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?w=400',
  },
];

export const areasOfImprovement = [
  { area: 'Digital Transformation', priority: 'High', potentialImpact: '$45M' },
  { area: 'Supply Chain Optimization', priority: 'High', potentialImpact: '$32M' },
  { area: 'Customer Experience', priority: 'Medium', potentialImpact: '$28M' },
  { area: 'Workforce Productivity', priority: 'Medium', potentialImpact: '$22M' },
  { area: 'Sustainability Initiatives', priority: 'Low', potentialImpact: '$15M' },
];

export const fiveYearRoadmap = [
  { year: 'Year 1', focus: 'Foundation', goals: ['Implement AI analytics', 'Establish baseline KPIs', 'Quick wins identification'] },
  { year: 'Year 2', focus: 'Optimization', goals: ['Process automation', 'Supply chain efficiency', 'Cost reduction targets'] },
  { year: 'Year 3', focus: 'Innovation', goals: ['New market expansion', 'Product innovation', 'Digital channels growth'] },
  { year: 'Year 4', focus: 'Scale', goals: ['Global operations', 'Strategic acquisitions', 'Market leadership'] },
  { year: 'Year 5', focus: 'Leadership', goals: ['Industry benchmark setter', 'Sustainable growth', 'Top performer status'] },
];

export const teamMembers = [
  {
    name: 'Dr. Vikram Mehta',
    role: 'Founder & CEO',
    bio: 'Former McKinsey Partner with 25+ years of experience in enterprise strategy and digital transformation.',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300',
  },
  {
    name: 'Priya Krishnamurthy',
    role: 'Chief Technology Officer',
    bio: 'AI/ML expert with experience at Google and Microsoft, leading development of enterprise AI solutions.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300',
  },
  {
    name: 'Arjun Reddy',
    role: 'Chief Analytics Officer',
    bio: 'PhD in Data Science from Stanford, pioneering work in financial analytics and benchmarking algorithms.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300',
  },
];

export const industries = [
  'Technology',
  'Manufacturing',
  'Healthcare',
  'Financial Services',
  'Retail',
  'Energy',
  'EPC (Engineering, Procurement & Construction)',
  'Telecommunications',
  'Pharmaceuticals',
];
